/**
 * Internally Dexie uses DB_VERSION * 10
 * https://github.com/dfahlander/Dexie.js/issues/59
 */

// Database name prefix.
export const DB_NAME_PREFIX = `MPW_Offline_DB`;

export const DB_TABLE_NAMES = [
  'AccessToken',
  'TransactionHistory',
  'TransactionHistoryErrorLogs',
  'SyncStatus',
  'Students',
  'ServingSites',
  'ServedItems',
  'ItemCategories',
  'NutritionCodes',
  'Sites',
  'Allergens',
  'TaxRatesByStatus',
];

// See docs about how to change/version the schema. https://dexie.org/docs/Tutorial/Design#database-versioning
export const DB_SCHEMAS = [
  {
    version: 7,
    schema: {
      AccessToken: 'Id, token',
      TransactionHistory:
        '++Id, [PrimarySiteId+MealType+StudentIdSeed+TransactionType+WorkingDT]',
      TransactionHistoryErrorLogs:
        '++Id, TransactionHistoryId, CreatedAt, Error',
      Students:
        '&Id, SiteId, IdSeed, FirstName, LastName, Teacher, ServingNumber, Balance',
      ServingSites: '&Id, Description, AlternateProvisionTypeId',
      // Served items are unique based on ItemId and SiteId
      ServedItems: '[ItemId+SiteId], SiteId',
      ItemCategories: 'Id, Description, Color',
      NutritionCodes: 'Id, Code, MealType, Description, ValidMealTypes',
      Sites: 'Id, PrimarySiteId, [Id+PrimarySiteId], SecondarySites',
      Allergens: 'Id, Description, Status',
    },
  },
  {
    version: 8,
    schema: {
      TaxRatesByStatus: '&Status',
    },
  },
  {
    version: 9,
    schema: {
      SyncStatus: 'StartAt',
    },
  },
];

export const SYNC_TRANSACTION_TAG = 'MPW_SYNC_TRANSACTION';

/**
 * Id for the stored token, only keep one token
 */
export const SYNC_ACCESS_TOKEN = 1;

/**
 * The timeout period between sync attempts.
 */
export const SYNC_TIMEOUT_MINUTES = 5;

/**
 * Amount of time in seconds before the offline prompt shows up after the server has gone down or the user has gone offline
 */
export const OFFLINE_PROMPT_DEBOUNCE = 20;



// WEBPACK FOOTER //
// ./src/common/Constants/offline.js